import React from 'react'
import Layout from "../components/App/Layout"
import Navbar from "../components/App/Navbar"
import PageBanner from '../components/Common/PageBanner'
import Footer from "../components/App/Footer"
import ServiceDetailsContentg from '../components/ServiceDetailsg/ServiceDetailsContentg'
import RelatedServicesg from '../components/ServiceDetailsg/RelatedServicesg'

const Details = () => {
    return (
        <Layout>
            <Navbar />
            <PageBanner
                pageTitle="Project Management "
                homePageText="Home"
                homePageUrl="/"
                activePageText="Service Details"
            />
            <ServiceDetailsContentg />
            <RelatedServicesg />
            <Footer />
        </Layout>
    );
}

export default Details